'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _objectEach = require('fast-loops/lib/objectEach');

var _objectEach2 = _interopRequireDefault(_objectEach);

var _createSubscription = require('./connection/createSubscription');

var _createSubscription2 = _interopRequireDefault(_createSubscription);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function render(renderer, targetDocument) {
  if (!renderer.updateSubscription) {
    renderer.scoreIndex = {};
    renderer.nodes = {};
    renderer.updateSubscription = (0, _createSubscription2.default)(renderer, targetDocument);
    renderer.subscribe(renderer.updateSubscription); // simulate rendering to ensure all styles rendered prior to
    // calling FelaDOM.render are correctly injected as well

    (0, _objectEach2.default)(renderer.cache, renderer._emitChange);
  }
}